<template>
    <div>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <router-view :place="place" v-else />
    </div>
  </template>
<script>
import { mapState } from 'pinia'
import { useRateStore } from '../../../stores'
import { clone } from 'ramda'

export default {
  data () {
    return {
      loading: true,
    }
  },
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useRateStore, ['httpGetRatesByPlace']),
  },
  methods: {
    clone,
  },
  created () {
    // load the extras
    const placeClone = this.clone(this.place)
    this.httpGetRatesByPlace({ place: placeClone })
      .then(() => {
        this.loading = false
      })
  },
}
</script>
